// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyAgrbdU-K_we48ygqPEWRJKQyjx6i3kN_k',
    authDomain: 'blueprintsalon-e3d81.firebaseapp.com',
    databaseURL: 'https://blueprintsalon-e3d81.firebaseio.com',
    projectId: 'blueprintsalon-e3d81',
    storageBucket: 'blueprintsalon-e3d81.appspot.com',
    messagingSenderId: '1029093030214',
    appId: '1:1029093030214:web:cf330d2ba6bd9dfef7cd47',
    measurementId: 'G-Z2HW4MS89E'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
